import { computed } from 'vue'
import { useWindowSize } from '@vueuse/core'

import { useSidebarPanelWidth } from '@/composables/useSidebarPanelWidth'

// How far the map canvas slides underneath the panel card. Matches the card's
// `rounded-r-3xl` radius so live map shows through the notches at its rounded
// corners and the border reads as an overlay on top of the map rather than a
// seam between two boxes.
export const MAP_BLEED = 24

const NAV_WIDTH = 74      // AppNavigation w-[74px]
const MIN_MAP_WIDTH = 240 // a Mapbox canvas resized to ~0 width is wasted work

// Geometry of the map stage relative to the left drawer. `uiInset` is where the
// panel card's right edge falls in stage coordinates (SidebarPanel is fixed at
// left-[74px] and <main> starts at the same x, so the published width needs no
// conversion); on-map UI must clear it. `canvasInset` is where the canvas box
// starts — one bleed short of it.
export const useMapInset = () => {
  const panelWidth = useSidebarPanelWidth()
  const { width: windowWidth } = useWindowSize()

  const uiInset = computed(() => {
    const max = Math.max(0, windowWidth.value - NAV_WIDTH - MIN_MAP_WIDTH)
    return Math.min(Math.max(0, panelWidth.value), max)
  })
  const canvasInset = computed(() => Math.max(0, uiInset.value - MAP_BLEED))
  const bleed = computed(() => uiInset.value - canvasInset.value)

  return { uiInset, canvasInset, bleed }
}
